"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActiveSessionsTableData = void 0;
var react_1 = __importStar(require("react"));
var date_fns_1 = require("date-fns");
// import { ActiveSession } from '@l2p/profile-api'
var next_intl_1 = require("next-intl");
var ui_components_1 = require("@l2p/ui-components");
var CurrentLabel_1 = __importDefault(require("../CurrentLabel"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var navigation_1 = require("next/navigation");
var useActiveSessionsTableData = function (data) {
    var t = (0, next_intl_1.useTranslations)('translation');
    var router = (0, navigation_1.useRouter)();
    var _a = (0, swr_hooks_1.useCloseSession)({
        successAction: router.refresh,
    }), closeSession = _a.closeSession, isSubmitting = _a.isSubmitting;
    return (0, react_1.useMemo)(function () {
        var table = {
            columns: [
                {
                    field: 'createdAt',
                    label: t('createdAt'),
                },
                {
                    field: 'ip',
                    label: t('ip'),
                },
                {
                    field: 'agent',
                    label: t('device'),
                },
                {
                    field: 'actions',
                    label: '',
                },
            ],
            rows: [],
        };
        table.rows =
            (data === null || data === void 0 ? void 0 : data.map(function (item) {
                var ip = item.ip, id = item.id, agent = item.agent, createdAt = item.createdAt, current = item.current;
                return {
                    createdAt: (0, date_fns_1.format)(new Date(createdAt), 'HH:mm, dd-LL-yy'),
                    ip: ip,
                    agent: agent,
                    actions: current ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.actionWrapper },
                        react_1.default.createElement(CurrentLabel_1.default, null))) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.actionWrapper },
                        react_1.default.createElement(ui_components_1.FixedButton, { width: "90px", height: "36px", variant: "outline", borderWidth: "1px", loading: isSubmitting, disabled: isSubmitting, onClick: function () {
                                closeSession({ id: id });
                            } }, t('close')))),
                };
            })) || [];
        return table;
    }, [closeSession, isSubmitting, data, t]);
};
exports.useActiveSessionsTableData = useActiveSessionsTableData;
